module.exports = __webpack_public_path__ + "img/分组 12.98aa3093.png";